import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  description: {
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap'
  }
}))
